<template>
<div class="chapter">
<div class="inner_page">
<p class="pnum"><a id="page_9"></a><a href="#/xhtml/06_Contents#pt1" id="pt1"><i>Part One</i></a></p>
<p class="pt"><a href="#/xhtml/06_Contents#pt1">Placing the Good within an Ethical Framework</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 09_Part01.vue?55c5d738